module.exports = __webpack_public_path__ + "static/media/kashtan.7ccfb805.jpg";